import { SVGProps, Ref, forwardRef } from 'react';

export const PrinterFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    d="M16 9.262c-.049 2.73-.49 3.668-2.463 3.955V9.5H2.468v3.717C.496 12.93.054 11.993.005 9.267c.064-3.543.787-4.068 4.663-4.068h6.669c3.874 0 4.599.524 4.663 4.063"
                    fill="currentColor"
                />
                <path d="M12.997.5H2.999V4h9.998z" fill="currentColor" />
                <path d="M3.666 15.499h8.664l.007-4.799H3.666z" fill="currentColor" />
            </g>
        </g>
    </svg>
));
PrinterFilledSize16Glyph.displayName = 'PrinterFilledSize16Glyph';
